import { useState } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import classNames from 'classnames'
import ErrorText from '../../../../components/form/ErrorText'

let idIndex = 0
const ColorPicker = ({
  value,
  colors = [],
  onChange = noop,
  disabled,
  error,
}) => {
  const [uniqIndex] = useState(idIndex++)
  const handleChange = ({ target }) => onChange(target.value)
  return colors.length === 0 ? (
    error ? (
      <ErrorText error={error} />
    ) : (
      <span className="txt_item">
        썸네일 이미지를 추가하면 배경 색상을 추천해 드립니다.
      </span>
    )
  ) : (
    <>
      <div className="item_color">
        <div className="color_radio">
          {colors.map(color => {
            const id = `inpColor${uniqIndex}/${color}`
            const checked = value === color
            return (
              <span
                key={id}
                className={classNames('box_radioinp', {
                  on: checked,
                  in_active: disabled,
                })}>
                <input
                  type="radio"
                  className="inp_radio"
                  name="inpColor"
                  id={id}
                  value={color}
                  checked={checked}
                  onChange={handleChange}
                />
                <label
                  htmlFor={id}
                  className="lab_radio"
                  style={{ background: color }}>
                  {color}
                </label>
              </span>
            )
          })}
        </div>
      </div>
      <ErrorText error={error} />
    </>
  )
}
ColorPicker.propTypes = {
  value: PropTypes.string,
  colors: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}
export default ColorPicker
